import { logUtil } from 'packages/src'

function toIntNumberUtil (value) {
  if (!value) {
    return 0
  }

  let val = parseInt(value, 10)
  if (Number.isNaN(val)) {
    logUtil('').warn('invalid value: ', value)
    val = 0
  }

  return val
}

export {
  toIntNumberUtil
}
